import Clarity from '@microsoft/clarity'
import Util from '@/assets/libs/util'
import { v4 as uuidv4 } from 'uuid'

const projectId = Util.getLocalConfigs('clarityProjectId')
let clarityinitialized = false
const generalConfig = Util.getGeneralInfo(false)
// x1dbt69fi2 Utilizado para Testes
/* @eventos:
- sessao_totem_iniciada (usuário iniciou atendimento)
- sessao_totem_finalizada (usuário finalizou atendimento)
- navegou_para_<nome_da_pagina> (usuário navegou para <nome_da_pagina>)
- usuario_adicionou_produto_ao_carrinho (usuário adicionou produto ao carrinho)
- usuario_removeu_produto_do_carrinho (usuário removeu produto do carrinho)
- usuario_limpou_carrinho (usuário esvaziou o carrinho)
- usuario_concluiu_pagamento (usuário concluiu o pagamento)
- usuario_aceitou_sugestao_checkout (usuário aceitou sugestão de produto no checkout) @TODO: verificar se é necessário (não está sendo usado)
- usuario_rejeitou_sugestao_checkout (usuário rejeitou sugestão de produto no checkout) @TODO: verificar se é necessário (não está sendo usado)
- usuario_realizou_login (usuário fez login) @TODO: verificar se é necessário (não está sendo usado)
- usuario_realizou_logout (usuário fez logout) @TODO: verificar se é necessário (não está sendo usado)
- erro_impressora (erro na impressora)
- pedido_para_levar (pedido para levar)
- pedido_consumo_local (pedido para consumir no local)
- sessao_encerrada_por_timeout (sessão encerrada por timeout)
- usuario_visualizou_categoria (usuário visualizou categoria)
- usuario_visualizou_produto (usuário visualizou produto)
- usuario_visualizou_subgrupo (usuário visualizou subgrupo)
- usuario_selecionou_observacao (usuário selecionou observação)
- usuario_removeu_observacao (usuário removeu observação)
- usuario_aceitou_sugestao_sabor (usuário aceitou sugestão de sabor)
- usuario_aceitou_sugestao_tamanho (usuário aceitou sugestão de tamanho)
- usuario_aceitou_sugestao_combo (usuário aceitou sugestão de combo)
- usuario_aceitou_sugestao_grupo_menu (usuário aceitou sugestão de grupo no menu)
- usuario_aceitou_sugestao_produto_menu (usuário aceitou sugestão de produto no menu)
- usuario_rejeitou_sugestao_menu (usuário rejeitou sugestão de menu)
- usuario_diminiu_quantidade_produto (usuário diminiu quantidade de produto)
- usuario_aumentou_quantidade_produto (usuário aumentou quantidade de produto)
- usuario_removeu_produto_do_carrinho (usuário removeu produto do carrinho)
- informou_telefone_para_fidelidade (usuário informou telefone para fidelidade)
*/
/*

@tags:
- url_atual (URL atual)
- id_unico_usuario (ID único do usuário)
- sugestao_produto_aceita (sugestão de produto no menu aceita - nome do produto) @TODO: verificar se é necessário
- sugestao_produto_checkout_aceita (sugestão de produto no checkout aceita - nome do produto) @TODO: verificar se é necessário
- produto_removido (produto removido do carrinho - nome do produto)
- metodo_pagamento (método de pagamento - nome do método)
- produto_adicionado_ao_carrinho (produto adicionado ao carrinho - quantidade x nome do produto)
- categoria_visualizada (categoria visualizada - nome da categoria)
- produto_visualizado (produto visualizado - nome do produto)
- subgrupo_visualizado (subgrupo visualizado - nome do subgrupo)
- observacao_selecionada (observação selecionada - nome da observação)
- observacao_deselecionada (observação removida - nome da observação)
- sugestao_sabor_aceita (sugestão de sabor aceita - nome do sabor)
- sugestao_tamanho_aceita (sugestão de tamanho aceita - nome do produto)
- sugestao_combo_aceita (sugestão de combo aceita - nome do produto)
- sugestao_grupo_menu_aceita (sugestão de grupo no menu aceita - nome do grupo)
- sugestao_produto_menu_aceita (sugestão de produto no menu aceita - nome do produto)
- quantidade_produto_diminiuida (quantidade de produto diminiuida - quantidade x nome do produto)
- quantidade_produto_aumentada (quantidade de produto aumentada - quantidade x nome do produto)
*/

const initClarity = () => {
    if (!projectId || projectId === '') {
        return
    }
    Clarity.init(projectId)
    Clarity.consent()
    Clarity.consentV2()
    clarityinitialized = true
}

const setTag = (tag, value) => {
    if (!clarityinitialized) {
        return
    }
    if (!value || value === '' || !tag || tag === '') {
        return
    }
    Util.logUsage('setTag', tag + ' - ' + value)
    // console.log('setTag', tag, value)
    Clarity.setTag(tag, value)
}

const event = (event) => {
    if (!clarityinitialized) {
        return
    }
    Util.logUsage('event', event)
    // console.log('event', event)
    Clarity.event(event)
}
const setUserUniqueId = () => {
    if (!clarityinitialized) {
        return
    }
    const atendimentoId = `${generalConfig.subsidiaryCode}-${generalConfig.storeCode}-${uuidv4()}`
    Clarity.identify(atendimentoId)
    event('sessao_totem_iniciada')
    setTag('id_unico_usuario', atendimentoId)
}

const stopSession = () => {
    // console.log('stopSession', clarityinitialized)
    if (!clarityinitialized) {
        return
    }
    window.clarity('stop')
}

const startSession = () => {
    if (!clarityinitialized) {
        return
    }
    // console.log('startSession', projectId)
    window.clarity('start', {
        projectId: projectId
    })
    upgrade('sessao_totem_iniciada')
}

const upgrade = (reason) => {
    // marca a sessão como prooritaria
    if (!clarityinitialized) {
        return
    }
    Clarity.upgrade(reason)
}
export default {
    initClarity,
    setTag,
    event,
    setUserUniqueId,
    upgrade,
    stopSession,
    startSession
}



// WEBPACK FOOTER //
// ./src/assets/controllers/ClarityController.js